<template>
  <v-card flat>
    <v-card-title>
      COMMANDS & TRADES
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="Object.values( accountCommands || commands == null ? {} : commands)"
      :search="search"
      :expanded.sync="expanded"
      sort-by="timestamp"
      sort-desc
      show-expand
      single-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-list dense color="transparent">
            <v-list-item v-for="trade in item.trades" :key="trade.timestamp">
              <v-list-item-content v-text="getPriceDecor('#'+trade.id)"></v-list-item-content>
              <v-list-item-content v-text="item.cmd"></v-list-item-content>
              <v-list-item-content v-text="trade.instrument"></v-list-item-content>
              <v-list-item-content v-text="getPriceDecor('@'+trade.price)"></v-list-item-content>
              <v-list-item-content v-text="getPriceDecor('stop@',trade.slPrice)"></v-list-item-content>
              <v-list-item-content v-text="getPriceDecor('take profit@',trade.tpPrice)"></v-list-item-content>
              <v-list-item-content v-text="getPriceDecor('trailing@', trade.tsPrice)"></v-list-item-content>
            </v-list-item>
          </v-list>
        </td>
      </template>
      <template v-slot:item.cmd="{ item }">
        <v-chip :color="getCmdColor(item.cmd)" dark>{{ item.cmd }}</v-chip>
      </template>
      <template v-slot:item.timestamp="{ item }">{{ getDate(item.timestamp) }}</template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { COMMAND } from "@/store/actions.type";
// import ApiService from "@/common/api.service";

export default {
  name: "Table",
  props: {
    accountId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      accountCommands: null,
      search: "",
      expanded: [],
      headers: [
        {
          text: "Instrument",
          align: "start",
          sortable: false,
          value: "fx"
        },
        { text: "Command", value: "cmd" },
        { text: "Account", value: "account.name" },
        { text: "Command Message", value: "cmdMessage" },
        { text: "Date", value: "timestamp" },
        { text: "", value: "data-table-expand" }
      ]
    };
  },
  computed: {
    ...mapGetters(["commands", "isAuthenticated", "currentUser"])
  },
  watch: {
    currentUser(val) {
      if (!this.commands) {
        this.$store.dispatch(COMMAND.FETCH, val.id);
      }
    }
  },
  mounted() {
    if (this.currentUser && !this.commands) {
      this.$store.dispatch(COMMAND.FETCH, this.currentUser.id);
    }
  },
  methods: {
    getCmdColor(item) {
      if (item === "buy") {
        return "primary darken-1";
      } else if (item === "sell") {
        return "red";
      }
    },
    getDate(timestamp) {
      let t = new Date(timestamp * 1000);
      return t.toDateString();
    },
    getPriceDecor(text, price) {
      if (price) {
        return "".concat(text, price);
      } else {
        return "".concat(text, 0);
      }
    }
    // getCommands(uid) {
    //   // ApiService.setHeader().then(() => {
    //   //   ApiService.get(`accounts/${uid}/commands`).then(result => {
    //   //     this.accountCommands = result.data;
    //   //   });
    //   // });
    // }
  }
};
</script>